module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/pickup-5-27f7cd8850ce84d89c29cd3c9d64ee8e.png";